module.exports = __webpack_public_path__ + "static/assets/62bfa00c79ed18b9101fa3acb7fabcc5.svg";